export const prepareProgramRegistrationInfo = {
  methods: {
    isActiveRegistrationByRole(role, program) {
      if (['child', 'parent'].includes(role)) {
        return !this.availableCamperRegistration
      }

      if (role === 'staff') {
        return !program.is_active_for_staff
      }

      return false
    },
    normalizeRoles(role) {
      const roleMap = {
        parent: 'Parent',
        staff: 'Staff',
        camper: 'Camper',
        child: 'Camper',
        student: 'Camper',
      }

      const roles = Array.isArray(role) ? role : [role]
      return roles.map(r => roleMap[r] || null).filter(Boolean)
    },
    getRelevantPreRegForms(program, preRegForms, role) {
      const normalizedRoles = this.normalizeRoles(role)

      return preRegForms.filter(form =>
        (form.linked_program_ids.includes(program.id) || form.linked_program_ids.length === 0) &&
        form.scope.some(scopeValue => normalizedRoles.includes(scopeValue))
      )
    },
    hasUnfilledForms(program, preRegForms, role, userId) {
      const forms = this.getRelevantPreRegForms(program, preRegForms, role)

      return forms.some(form => {
        const userResult = form.results?.find(r => r.user_id == userId)
        return !userResult || userResult.status !== 'Approved'
      })
    },
    hasUnfilledRequiredForms(program, preRegForms, role, userId) {
      const forms = this.getRelevantPreRegForms(program, preRegForms, role)

      return forms.some(form => {
        if (!form.is_required) return false
        const userResult = form.results?.find(r => r.user_id == userId)
        return !userResult || userResult.status !== 'Approved'
      })
    },
    getProgramRegistrationLinkByRole(role, program) {
      if (['child', 'staff'].includes(role)) {
        return {name: 'application-create', params: { id: program.id }}
      }

      if (role === 'parent') {
        return {name: 'application-select-child', params: { id: program.id }}
      }
    },
    getApplicationPageLinkForChild(child, programId) {
      if (child.applicationsByProgram[programId] === undefined) {
        return {
          name: 'application-create',
          params: { id: programId },
          query: { user_id: child.id }
        }
      }
      return {
        name: 'application-create',
        params: { id: programId },
        query: {
          app_id: child.applicationsByProgram[programId].id,
          user_id: child.id,
        }
      }
    },
    findApplicationLink(program, role) {
      return program.applicationsByProgram
        ? this.getApplicationLinkByRole(program)
        : this.getProgramRegistrationLinkByRole(role, program)
    },
    getApplicationLinkByRole(program) {
      return {
        name: 'application-create',
        params: { id: program.id },
        query: {
          app_id: program.applicationsByProgram.id,
          user_id: program.applicationsByProgram.user_id,
        },
      }
    },
    isDisabledRegistrationByGender(role, gender, program) {
      if (!gender) {
        return false
      }

      if (['staff', 'parent'].includes(role)) {
        return false
      }

      if (role === 'child') {
        return this.checkProgramRegistrationIsDisableByGender(gender, program.gender)
      }

      return false
    },
    checkProgramRegistrationIsDisableByGender(gender, programGender) {
      const maleValues = ['boy', 'male']
      const femaleValues = ['girl', 'female']

      if (!gender) {
        return false
      }

      if (programGender === 'Both') {
        return false
      }

      if (programGender === 'Male' && maleValues.indexOf(gender.toLowerCase()) === -1) {
        return true
      }

      if (programGender === 'Female' && femaleValues.indexOf(gender.toLowerCase()) === -1) {
        return true
      }

      return false
    },
    getDefaultGenderForProgram(programGender, authSettings) {
      if (programGender === 'Boys') {
        return "Male"
      }

      if (programGender === 'Girls') {
        return "Female"
      }

      if (programGender === 'Both') {
        return authSettings.default_gender
      }
    },
    availableRegularLogin(chosenRole, authSettings) {
      if (chosenRole === 'staff' && authSettings.enable_regular_login_for_staff) {
        return true
      }
      if (chosenRole && chosenRole !== 'staff' && authSettings.enable_regular_login_for_parents) {
        return true
      }
      return false
    },
    availableRegularRegistration(chosenRole, authSettings) {
      if (chosenRole === 'staff' && authSettings.enable_regular_registration_for_staff) {
        return true
      }
      if (chosenRole && chosenRole !== 'staff' && authSettings.enable_regular_registration_for_parents) {
        return true
      }
      return false
    },
    availableOauthLogin(chosenRole, authSettings) {
      if (chosenRole === 'staff' && authSettings.enable_oauth_login_for_staff) {
        return true
      }
      if (chosenRole && chosenRole !== 'staff' && authSettings.enable_oauth_login_for_parents) {
        return true
      }
      return false
    },
    availableOauthRegistration(chosenRole, authSettings) {
      if (chosenRole === 'staff' && authSettings.enable_oauth_registration_for_staff) {
        return true
      }
      if (chosenRole && chosenRole !== 'staff' && authSettings.enable_oauth_registration_for_parents) {
        return true
      }
      return false
    },
  },
}

export const _ = null
